import { Collapse } from 'bootstrap';

class VisitorValidator {

    constructor(el, validationCall) {
        this.el = el;
        this.validationCall = validationCall;
        this.amount = 0;
        this.validations = [];
        // find form-number-control elements
        this.formNumberControl = el.querySelector('.form-number-control');
        if (this.formNumberControl != null) {
            this.formNumberControlInput = this.formNumberControl.querySelector('input');
            this.id = this.formNumberControlInput.getAttribute('id');
            this.name = this.formNumberControlInput.getAttribute('name');
            // find validation collapse area
            this.validationCollapseEl = el.querySelector('.visitors-quantity-selector--visitor-type--validation');
            this.validationCollapse = Collapse.getOrCreateInstance(this.validationCollapseEl, {
                toggle: false
            });
            this.validationCollapseContent = el.querySelector('.visitors-quantity-selector--visitor-type--validation--content');
            // add listener to form-number-control for change event
            this.formNumberControlInput.addEventListener('change', (e) => {
                this.updateValidation();
            }, false);
        }
    }

    updateValidation() {
        // get current form-number-control value as integer
        this.amount = parseInt(this.formNumberControlInput.value);
        if (this.amount != this.validations.length) {
            if (this.amount > this.validations.length) {
                // increased
                // loop to create as many new instances as necessary
                for (let x = this.validations.length, l = this.amount; x < l; x++) {
                    // create, append and wire-up html
                    this.createValidatorItem(x);
                    // expand?
                    if (x == 0) {
                        this.validationCollapse.show();
                        this.validationCollapseEl.setAttribute('aria-hidden', false);
                    }
                }
            } else {
                // decreased
                // collapse?
                if (this.amount == 0) {
                    this.validationCollapse.hide();
                    this.validationCollapseEl.setAttribute('aria-hidden', true);
                }
                // remove elements
                for (let x = (this.validations.length - 1), l = this.amount; x >= l; x = x - 1) {
                    let n = this.validationCollapseContent.querySelector(`#${this.id}--validation-item-${x}`);
                    this.validationCollapseContent.removeChild(n);
                }
                // update validations array length
                this.validations.length = this.amount;
            }
        }
    }

    createValidatorItem(index) {
        // create html
        let n = document.createElement('div');
        n.classList.add('validation-item', 'form-group');
        n.id = `${this.id}--validation-item-${index}`;
        let c = `<label for="${this.id}--validation-item-${index}--member-number" class="d-block form-label mb-2">Member card number ${index > 0 ? index + 1 : ''}</label>`;
        c += `<p class="mb-0"><input type="text" class="form-control form-control-sm d-inline-block mw-300 mb-2 js-member-card-number" name="${this.name.replace('Quantity', 'MemberCardNumbers')}[${index}]" id="${this.id}--validation-item-${index}--member-number" /> `;
        c += `<button type="button" disabled="disabled" class="btn btn-theme btn-sm btn-secondary mb-2">Validate</button></p>`;
        c += `<div class="validation-message"></div>`;
        n.innerHTML = c;
        // push item values to validations array
        this.validations[index] = {
            field: n.querySelector(`#${this.id}--validation-item-${index}--member-number`),
            btn: n.querySelector('.btn'),
            validationEl: n.querySelector('.validation-message'),
            valid: false,
        };
        // get elements and add behaviours
        this.validations[index].btn.onclick = () => { // btn click
            this.validateNumber(index);
        }
        this.validations[index].field.onkeyup = (e) => { // change to field after successful validation
            console.log('onkeyup', e);

            this.validations[index].btn.disabled = e.target.value == '';
        }
        // append html to validation content section
        this.validationCollapseContent.appendChild(n);
    }

    updateValidationUi(validations, index, message) {
        if (validations[index].valid) {
            // valid
            validations[index].validationEl.innerHTML = `<div class="text-success small"><i class="far fa-check me-2"></i>${message}</div>`;
            validations[index].field.classList.add('is-valid');
            validations[index].field.classList.remove('is-invalid');
        } else {
            // invalid
            validations[index].validationEl.innerHTML = `<div class="text-danger small"><i class="far fa-exclamation-circle me-2"></i>${message}</div>`;
            validations[index].field.classList.add('is-invalid');
            validations[index].field.classList.remove('is-valid');
        }
    }

    validateNumber(index) {
        if (this.validationCall) {
            this.validationCall(this.validations, index, this.updateValidationUi);
        }
        else {
            // this function has dummy code for now - will validate member numbers
            this.validations[index].valid = !this.validations[index].valid;
            // handle result

            const message = true
                ? 'Number is valid.'
                : 'Number is not valid. Please <a href="#">contact us</a> if you have any questions.';

            this.updateValidationUi(this.validations, index, message);
        }
    }

}

export function createFrom(wrappers, validationCall) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new VisitorValidator(node, validationCall);
        }
    });
}